import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 1,
  class: "mb-64"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " My Boundary ")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "grid grid--xs flex flex--wrap flex--align-stretch flex--row-gap-medium" }
const _hoisted_5 = { class: "grid__item a3-12 d3-6 f6-6" }
const _hoisted_6 = { class: "grid__item a3-12 d3-6 f6-6" }
const _hoisted_7 = { class: "grid__item a3-12 d3-6 f6-6" }
const _hoisted_8 = { class: "grid__item a3-12 d3-6 f6-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_SupportCardComponent = _resolveComponent("SupportCardComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_SupportCardComponent, {
                    title: "Onboarding slideshows",
                    icon: "slides",
                    colour: "sand",
                    slideshows: $data.onboarding_slideshows,
                    "show-visibility-toggle": $options.user_is_staff
                  }, null, 8 /* PROPS */, ["slideshows", "show-visibility-toggle"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SupportCardComponent, {
                    title: "Documentation",
                    icon: "book",
                    colour: "forest-green",
                    links: $data.documentation_pages,
                    "show-visibility-toggle": $options.user_is_staff
                  }, null, 8 /* PROPS */, ["links", "show-visibility-toggle"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_SupportCardComponent, {
                    title: "ABC Work stages",
                    icon: "images",
                    colour: "light-green",
                    slideshows: $data.abc_work_stages
                  }, null, 8 /* PROPS */, ["slideshows"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_SupportCardComponent, {
                    title: "TBL Development",
                    icon: "sparkle",
                    colour: "clay-orange",
                    "is-development-card": true
                  })
                ])
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}